import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterSSDIPageConciergeDownload = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("ssdi/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ConciergeDownloadPage />,
        });
      })
      .catch(reject);
  });
});

export const LazySSDIPageConciergeDownload = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterSSDIPageConciergeDownload />
    </Suspense>
  );
};
